import React, { useState, useEffect } from 'react';
import { Dialog, Box, Grid } from '@mui/material';
import * as yup from 'yup';
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormInputText from '../common/Forms/FormTextField';
import FormInputMultiCheckbox from '../common/Forms/FormCheckbox';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import EpisodeDropdown from '../common/Forms/EpisodeDropdown';
import moment from 'moment';
import {
  fieldRequired,
  formDateFormat,
  NEW_EPISODE_UPDATE_DATA,
  EPISODE_BASE_URL,
  EPISODE_AUTH_LIST_URL,
  paperProps2,
  maxLength
} from '../../constants';
import {
  setActualAPRD,
  setArea,
  setCCCMS,
  setCDCNumber,
  setEpisodeComment,
  setEpisodeDischargeDate,
  setEpisodeDischargeReason,
  setEpisodeSAPStartDate,
  setEprd,
  setInactivity,
  setIncarcerationInstitution,
  setLastCountyofResidence,
  setParoleAgent,
  setParoleCounty,
  setReferralSource,
  setTIR,
} from '../../redux/participant/newEpisode/NewEpisodeSlice';
import { getStopApi, postStopApi, setStopApi, deleteStopApi } from '../../services/StopApi/StopApi';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../common/commonUtils/commonUtils';

const schema = yup.object().shape({
  episodeSAPStartDate: yup.date().typeError(fieldRequired).required(),
  expectedEPRD: yup.string(),
  actualAPRD: yup.string(),
  incarcerationInstitutionId: yup.string().required(fieldRequired),
  referralSourceId: yup.string().required(fieldRequired),
  cDCNumber: yup
    .string()
    .required(fieldRequired)
    //.matches(/^[C]\d+$/, 'Should starts with C and digits')
    .min(6, 'This field has minimum of six characters')
    .max(6, 'This field has maximum of six characters'),
  //lastCountyofResidenceId: yup.string().required(fieldRequired),
  //paroleAgentId: yup.string().required(fieldRequired),
  //paroleCountyId: yup.string().required(fieldRequired),
  areaId: yup.string().required(fieldRequired),
  episodeDischargeDate: yup.string(), // date().typeError(fieldRequired),
  episodeDischargeReasonId: yup.string(),
  episodeComment: yup.string().nullable().max(800, `${maxLength} 800`),
});

export default function EpisodeDialog(props) {
  const STOP_REGION = process.env.REACT_APP_STOP_REGION
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const {
    open,
    setOpen,
    partcipantId,
    fetchData,
    authToken,
    disableNewEpisode,
    openBackdrop,
    user
  } = props;
  //console.log(user)
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewEpisode, setIsNewEpisode] = useState(false);
  const [filteredReferralSource, setFilteredReferralSource] = useState([]);
  const [hasActiveAuths, setHasActiveAuths] = useState(false);
  const newEpisodeReferenceData = useSelector(
    (state) => state.newEpisodeReferenceData
  );
  const newEpisodeForm = useSelector(
    (state) => state.newEpisodeFormData?.newEpisode
  );

  //console.log('### newEpisodeReferenceData')
  //console.log(newEpisodeReferenceData)
  
  //console.log('### newEpisodeForm')
  //console.log(newEpisodeForm)
  
  if (!newEpisodeForm.areaId) {
    //newEpisodeForm.areaId = STOP_REGION === 1 ? 1 : 3;
    dispatch(setArea(STOP_REGION == 1 ? 1 : 3))
  }
  const [date, setDate] = useState('');
  const todayDate = new Date();
  todayDate.setDate(todayDate.getDate());
  const dateString = todayDate.toISOString().split('T')[0];
  const defaultValue = {
    episodeId: newEpisodeForm?.episodeID,
    episodeSAPStartDate: moment(newEpisodeForm?.episodeSAPStartDate).format(
      formDateFormat
    ),
    expectedEPRD: moment(newEpisodeForm?.expectedEPRD).format(formDateFormat),
    actualAPRD: moment(newEpisodeForm?.actualAPRD).format(formDateFormat),
    incarcerationInstitutionId: newEpisodeForm?.incarcerationInstitutionId
      ? newEpisodeForm?.incarcerationInstitutionId
      : '',
    referralSourceId: newEpisodeForm?.referralSourceId
      ? newEpisodeForm?.referralSourceId
      : '',
    cDCNumber: newEpisodeForm?.cDCNumber,
    episodeComment: newEpisodeForm?.episodeComment,
    lastCountyofResidenceId: newEpisodeForm?.lastCountyofResidenceId
      ? newEpisodeForm?.lastCountyofResidenceId
      : '',
    paroleAgentId: newEpisodeForm?.paroleAgentId
      ? newEpisodeForm?.paroleAgentId
      : '',
    paroleCountyId: newEpisodeForm?.paroleCountyId
      ? newEpisodeForm?.paroleCountyId
      : '',
    cCCMS: newEpisodeForm?.cCCMS ? newEpisodeForm?.cCCMS : false,
    tIR: newEpisodeForm?.tIR ? newEpisodeForm?.tIR : false,
    areaId: newEpisodeForm?.areaId ? newEpisodeForm?.areaId : '',
    episodeDischargeDate: moment(newEpisodeForm?.episodeDischargeDate).format(
      formDateFormat
    ),
    episodeDischargeReasonId: newEpisodeForm?.episodeDischargeReasonId
      ? newEpisodeForm?.episodeDischargeReasonId
      : '',
    inactivity: newEpisodeForm?.inactivity ? newEpisodeForm?.inactivity : false,
  };
  const { control, formState, handleSubmit, reset, register } = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });

  const { errors } = formState;

  const incarcerationInstitutionId = useWatch({
    control,
    name: 'incarcerationInstitutionId',
  });
  useEffect(() => {
    //console.log('### incarcerationInstitutionId')
    //console.log(incarcerationInstitutionId)
    setFilteredReferralSource(newEpisodeReferenceData?.referralSource.filter(r => r.institutionOrgId==incarcerationInstitutionId))
  }, [
    incarcerationInstitutionId
  ]);

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.episodeId,
    defaultValue.episodeSAPStartDate,
    defaultValue.expectedEPRD,
    defaultValue.actualAPRD,
    defaultValue.incarcerationInstitutionId,
    defaultValue.referralSourceId,
    defaultValue.cDCNumber,
    defaultValue.episodeComment,
    defaultValue.lastCountyofResidenceId,
    defaultValue.paroleAgentId,
    defaultValue.paroleCountyId,
    defaultValue.cCCMS,
    defaultValue.tIR,
    defaultValue.areaId,
    defaultValue.episodeDischargeDate,
    defaultValue.episodeDischargeReasonId,
    defaultValue.inactivity,
  ]);

  // Fetch authList and check for active auths when editing an existing episode
  useEffect(() => {
    const checkActiveAuths = (authList) => {
      const currentDate = new Date();
      return authList.some(auth => {
        // Check if CBP Admit Date exists without Discharge Date
        if (auth.cbpDischargeDate) {
          return false;
        }
        if (auth.cbpAdmitDate && !auth.cbpDischargeDate) {
          return true;
        }
        // Check if current date is between Auth Start Date and Auth Overall End Date
        if (auth.authStartDate && auth.overAllEndDate) {
          const startDate = new Date(auth.authStartDate);
          const endDate = new Date(auth.overAllEndDate);
          if (currentDate >= startDate && currentDate <= endDate) {
            return true;
          }
        }
        return false;
      });
    };

    if (open && newEpisodeForm?.episodeID && !newEpisodeForm?.newEpisodeLoaded) {
      const episodeId = newEpisodeForm.episodeID;
      const commonParams = `${EPISODE_AUTH_LIST_URL}/${episodeId}/authList`;
      const authorization = authToken;

      getStopApi({ commonParams, authorization })
        .then((response) => {
          if (response.succeeded && response.data) {
            const hasActive = checkActiveAuths(response.data);
            setHasActiveAuths(hasActive);
          }
        })
        .catch((e) => {
          console.error('Error fetching authList:', e);
          setHasActiveAuths(false);
        });
    } else {
      // Reset when dialog closes or for new episodes
      setHasActiveAuths(false);
    }
  }, [open, newEpisodeForm?.episodeID, newEpisodeForm?.newEpisodeLoaded, authToken]);

  const onSubmit = () => {
    if (!isSubmitting) {
      try {
        setIsSubmitting(true);
        const url = `${NEW_EPISODE_UPDATE_DATA}/${partcipantId}/PrtEpisode`;
        const authorization = authToken;
        const payload = {
          episodeID: newEpisodeForm?.episodeID,
          episodeSAPStartDate:
            newEpisodeForm?.episodeSAPStartDate === ''
              ? null
              : moment(newEpisodeForm?.episodeSAPStartDate).format(formDateFormat),
          expectedEPRD:
            newEpisodeForm?.expectedEPRD === ''
              ? null
              : moment(newEpisodeForm?.expectedEPRD).format(formDateFormat),
          actualAPRD:
            newEpisodeForm?.actualAPRD === ''
              ? null
              : moment(newEpisodeForm?.actualAPRD).format(formDateFormat),
          incaretionInstitutionId:
            newEpisodeForm?.incarcerationInstitutionId === ' '
              ? null
              : newEpisodeForm?.incarcerationInstitutionId,
          referralSourceId:
            newEpisodeForm?.referralSourceId === ''
              ? null
              : newEpisodeForm?.referralSourceId,
          cDCNumber:
            newEpisodeForm?.cDCNumber === '' ? null : newEpisodeForm?.cDCNumber,
          episodeComment: newEpisodeForm?.episodeComment ?? '' ,
          cCCMS: newEpisodeForm?.cCCMS,
          lastCountyOfResidenceId:
            newEpisodeForm?.lastCountyofResidenceId === ''
              ? null
              : newEpisodeForm?.lastCountyofResidenceId,
          paroleCountyId:
            newEpisodeForm?.paroleCountyId === ''
              ? null
              : newEpisodeForm?.paroleCountyId,
          paroleAgentId:
            newEpisodeForm?.paroleAgentId === ''
              ? null
              : newEpisodeForm?.paroleAgentId,
          tIR: newEpisodeForm?.tIR,
          areaId: newEpisodeForm?.areaId === '' ? null : newEpisodeForm?.areaId,
          episodeDischargeDate:
            newEpisodeForm?.episodeDischargeDate === ''
              ? null
              : moment(newEpisodeForm?.episodeDischargeDate).format(formDateFormat),
          inactivity: newEpisodeForm?.inactivity,
          episodeDischargeReason:
            newEpisodeForm?.episodeDischargeReasonId === ''
              ? null
              : newEpisodeForm?.episodeDischargeReasonId,
          episodeEditedby: user?.contact?.cntId    

        };
        if (newEpisodeForm?.newEpisodeLoaded) {
          const payload = {
            episodeSAPStartDate:
              newEpisodeForm?.episodeSAPStartDate === ''
                ? null
                : moment(newEpisodeForm?.episodeSAPStartDate).format(
                    formDateFormat
                  ),
            expectedEPRD:
              newEpisodeForm?.expectedEPRD === ''
                ? null
                : moment(newEpisodeForm?.expectedEPRD).format(formDateFormat),
            actualAPRD:
              newEpisodeForm?.actualAPRD === ''
                ? null
                : moment(newEpisodeForm?.actualAPRD).format(formDateFormat),
            incaretionInstitutionId:
              newEpisodeForm?.incarcerationInstitutionId === ''
                ? null
                : newEpisodeForm?.incarcerationInstitutionId,
            referralSourceId:
              newEpisodeForm?.referralSourceId === ''
                ? null
                : newEpisodeForm?.referralSourceId,
            cDCNumber:
              newEpisodeForm?.cDCNumber === '' ? null : newEpisodeForm?.cDCNumber,
            episodeComment: newEpisodeForm?.episodeComment ?? '',

            cCCMS: newEpisodeForm?.cCCMS === '' ? null : newEpisodeForm?.cCCMS,
            lastCountyOfResidenceId:
              newEpisodeForm?.lastCountyofResidenceId === ''
                ? null
                : newEpisodeForm?.lastCountyofResidenceId,
            paroleCountyId:
              newEpisodeForm?.paroleCountyId === ''
                ? null
                : newEpisodeForm?.paroleCountyId,
            paroleAgentId:
              newEpisodeForm?.paroleAgentId === ''
                ? null
                : newEpisodeForm?.paroleAgentId,
            tIR: newEpisodeForm?.tIR === '' ? null : newEpisodeForm?.tIR,
            areaId: newEpisodeForm?.areaId === '' ? null : newEpisodeForm?.areaId,
            episodeDischargeDate:
              newEpisodeForm?.episodeDischargeDate === ''
                ? null
                : moment(newEpisodeForm?.episodeDischargeDate).format(
                    formDateFormat
                  ),
            inactivity:
              newEpisodeForm?.inactivity === '' ? null : newEpisodeForm?.inactivity,
            episodeDischargeReason:
              newEpisodeForm?.episodeDischargeReasonId === ''
                ? null
                : newEpisodeForm?.episodeDischargeReasonId,
            episodeCreatedby: user?.contact?.cntId,
            episodeEditedby: user?.contact?.cntId    
          };
          postStopApi({ url, payload, authorization }).then((response) => {
            if (response.succeeded === true) {
              fetchData();
              setFormSuccess(true);
              setIsNewEpisode(true);
              setOpen(false);
            }
          }).catch((e) => alert(e));
        } else {
          setStopApi({ url, payload, authorization }).then((response) => {
            if (response.succeeded === true) {
              fetchData();
              setFormSuccess(true);
              setIsNewEpisode(false);
              setOpen(false);
            }
          })
          .catch((e) => alert(e));
        }
      }
      catch (e) {
        alert('error saving episode: ' + e.message);
      }
      finally {
        setIsSubmitting(false);
      }
    }  
  };

  const handleClose = () => {
    reset(defaultValue);
    setOpen(false);
  };

  const handleDelete = () => {
    const episodeId = newEpisodeForm?.episodeID;
    const url = `${EPISODE_BASE_URL}/episode/${episodeId}`;
    const authorization = authToken;
    const payload = {};
    deleteStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchData();
        handleClose();
      }
    }).catch((e) => alert(e));
  };



  return (
    <>
      <Dialog open={open} PaperProps={paperProps2}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>
            {getDialogHeading(
              'Episode Id',
              defaultValue?.episodeId,
              handleClose
            )}
            <form>
              <Grid container spacing={6} style={{ padding: '10px 40px' }}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <FormInputText
                    name='episodeSAPStartDate'
                    control={control}
                    label='Episode SAP Start Date'
                    type='date'
                    errors={!!errors.episodeSAPStartDate}
                    helperText={errors?.episodeSAPStartDate?.message}
                    shrink={true}
                    register={register('episodeSAPStartDate', {
                      onChange: (e) =>
                        dispatch(setEpisodeSAPStartDate(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='expectedEPRD'
                    control={control}
                    label='EPRD'
                    type='date'
                    errors={!!errors.expectedEPRD}
                    helperText={errors?.expectedEPRD?.message}
                    shrink={true}
                    register={register('expectedEPRD', {
                      onChange: (e) => dispatch(setEprd(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='actualAPRD'
                    control={control}
                    label='Actual'
                    type='date'
                    maxValue={dateString}
                    errors={!!errors.actualAPRD}
                    helperText={errors?.actualAPRD?.message}
                    shrink={true}
                    register={register('actualAPRD', {
                      onChange: (e) => dispatch(setActualAPRD(e.target.value)),
                    })}
                  />
                  <EpisodeDropdown
                    name='incarcerationInstitutionId'
                    control={control}
                    label='Incarceration Institution'
                    options={newEpisodeReferenceData?.incarcerationInstitutions}
                    defaultId={defaultValue?.incarcerationInstitutionId}
                    isIncarcerationInstitution={true}
                    errors={!!errors.incarcerationInstitutionId}
                    helperText={errors?.incarcerationInstitutionId?.message}
                    register={register('incarcerationInstitutionId', {
                      onChange: (e) => {
                        dispatch(setIncarcerationInstitution(e.target.value));
                        //if (newEpisodeReferenceData?.referralSource)
                        //  setFilteredReferralSource(newEpisodeReferenceData?.referralSource.filter(r => r.institutionOrgId==e.target.value))
                      }
                    })}
                  />
                  <EpisodeDropdown
                    name='referralSourceId'
                    control={control}
                    label='Referral Source'
                    options={filteredReferralSource}
                    defaultId={defaultValue?.referralSourceId}
                    isReferralSource={true}
                    errors={!!errors.referralSourceId}
                    helperText={errors?.referralSourceId?.message}
                    register={register('referralSourceId', {
                      onChange: (e) =>
                        dispatch(setReferralSource(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='cDCNumber'
                    control={control}
                    label='CDC Number'
                    errors={!!errors.cDCNumber}
                    helperText={errors?.cDCNumber?.message}
                    register={register('cDCNumber', {
                      onChange: (e) => dispatch(setCDCNumber(e.target.value)),
                    })}
                  />
                  <EpisodeDropdown
                    name='lastCountyofResidenceId'
                    control={control}
                    label='Last County of Residence'
                    options={newEpisodeReferenceData?.lastCountryOfResidence}
                    defaultId={defaultValue?.lastCountyofResidenceId}
                    errors={!!errors.lastCountyofResidenceId}
                    helperText={errors?.lastCountyofResidenceId?.message}
                    register={register('lastCountyofResidenceId', {
                      onChange: (e) =>
                        dispatch(setLastCountyofResidence(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <EpisodeDropdown
                    name='paroleCountyId'
                    control={control}
                    label='Parole County'
                    options={newEpisodeReferenceData?.paroleCountry}
                    defaultId={defaultValue?.paroleCountyId}
                    errors={!!errors.paroleCountyId}
                    helperText={errors?.paroleCountyId?.message}
                    register={register('paroleCountyId', {
                      onChange: (e) =>
                        dispatch(setParoleCounty(e.target.value)),
                    })}
                  />
                  <EpisodeDropdown
                    name='paroleAgentId'
                    control={control}
                    label='Parole Agent'
                    options={newEpisodeReferenceData?.paroleAgent}
                    defaultId={defaultValue?.paroleAgentId}
                    isParoleAgent={true}
                    errors={!!errors.paroleAgentId}
                    helperText={errors?.paroleAgentId?.message}
                    register={register('paroleAgentId', {
                      onChange: (e) => dispatch(setParoleAgent(e.target.value)),
                    })}
                  />
                  <EpisodeDropdown
                    name='areaId'
                    control={control}
                    label='Area'
                    options={newEpisodeReferenceData?.area}
                    defaultId={defaultValue?.areaId}
                    errors={!!errors.areaId}
                    helperText={errors?.areaId?.message}
                    register={register('areaId', {
                      onChange: (e) => dispatch(setArea(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='episodeDischargeDate'
                    control={control}
                    label='Episode Discharge Date'
                    type='date'
                    maxValue={dateString}
                    errors={!!errors.episodeDischargeDate}
                    helperText={errors?.episodeDischargeDate?.message}
                    shrink={true}
                    register={register('episodeDischargeDate', {
                      onChange: (e) => {
                        dispatch(setEpisodeDischargeDate(e.target.value));
                        if (!e.target.value) {
                          dispatch(setEpisodeDischargeReason(''));  
                        }
                      }
                    })}
                  />
                  <EpisodeDropdown
                    name='episodeDischargeReasonId'
                    control={control}
                    label='Episode Discharge Reason'
                    options={newEpisodeReferenceData?.epdDischargeReason}
                    defaultId={defaultValue?.episodeDischargeReasonId}
                    errors={!!errors.episodeDischargeReasonId}
                    helperText={errors?.episodeDischargeReasonId?.message}
                    register={register('episodeDischargeReasonId', {
                      onChange: (e) =>
                        dispatch(setEpisodeDischargeReason(e.target.value)),
                    })}
                  />
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <FormInputMultiCheckbox
                      name='tIR'
                      control={control}
                      variant='outlined'
                      label='TIR'
                      checked={defaultValue.tIR}
                      error={!!errors.tIR}
                      helperText={errors?.tIR?.message}
                      register={register('tIR', {
                        onChange: (e) => dispatch(setTIR(e.target.value)),
                      })}
                    />
                  </Box>
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <FormInputMultiCheckbox
                      name='cCCMS'
                      control={control}
                      variant='outlined'
                      label='CCC Ms'
                      checked={defaultValue.cCCMS}
                      error={!!errors.cCCMS}
                      helperText={errors?.cCCMS?.message}
                      register={register('cCCMS', {
                        onChange: (e) => dispatch(setCCCMS(e.target.value)),
                      })}
                    />
                  </Box>
                  {newEpisodeForm?.newEpisodeLoaded === true ? (
                    ''
                  ) : (
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <FormInputMultiCheckbox
                        name='inactivity'
                        control={control}
                        variant='outlined'
                        label='Inactive'
                        disabled={
                          hasActiveAuths ? true :
                          newEpisodeForm?.inactivity ===
                          disableNewEpisode[0]?.inactivity
                            ? false
                            : disableNewEpisode == ''
                            ? false
                            : true
                        }
                        checked={defaultValue.inactivity}
                        error={!!errors.inactivity}
                        helperText={errors?.inactivity?.message}
                        register={register('inactivity', {
                          onChange: (e) =>
                            dispatch(setInactivity(e.target.value)),
                        })}
                      />
                    </Box>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ marginTop: "-40px" }}
                >
                  <FormInputText
                    name='episodeComment'
                    multiline
                    rows={5}
                    control={control}
                    label='Comment'
                    errors={!!errors.episodeComment}
                    register={register('episodeComment', {
                      onChange: (e) => dispatch(setEpisodeComment(e.target.value)),
                    })}
                    helperText={errors?.episodeComment?.message}
                  />
                  {getSaveCancel(handleClose, user?.contact?.dataEntry && !newEpisodeForm?.newEpisodeLoaded ? handleDelete : null, handleSubmit(onSubmit), isSubmitting)}
                </Grid>
              </Grid>
            </form>
          </>
        )}
      </Dialog>
      {getFormSuccess(formSuccess, setFormSuccess, isNewEpisode)}
    </>
  );
}
